import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'

import { type UpdateMovePayload, type Move } from '../../../modules/moves'
import { SpecialItem } from '../../../common/specialItem'
import Form, { QuantityCollectionField, SubmitButton } from '../../Form'
import { Subtitle } from '../../typography'
import { formatFormOutput, moveToFormData } from './formDataBuilder'
import { type SpecialItemsFormValues } from './SpecialItemsForm.type'
import { useGetMoveRequestPayload } from '../../../modules/moves/core/moveRequest.hooks'

type SpecialItemsFormProps = {
  move: Move
  onSubmit: (data: UpdateMovePayload) => Promise<void> | void
}

const SpecialItemsForm: React.FC<SpecialItemsFormProps> = ({
  move,
  onSubmit,
}) => {
  const { t } = useTranslation()
  const getMoveRequestPayload = useGetMoveRequestPayload()

  const form = useForm({
    defaultValues: moveToFormData(move),
  })

  const handleSubmit = async (data: SpecialItemsFormValues) => {
    const payload = getMoveRequestPayload(move, formatFormOutput(data).request)

    await onSubmit({ request: payload })
  }

  const specialItemsOptions = Object.values(SpecialItem).map(specialItem => ({
    value: specialItem,
    label: t(`specialItems.${specialItem}.title`),
  }))

  return (
    <div className="text-center">
      <Form form={form} onSubmit={handleSubmit}>

        <Subtitle className="mb-12 mt-6 lg:text-center">
          { t('forms.specialItems.title') }
        </Subtitle>

        <QuantityCollectionField
          name="specialItems"
          options={specialItemsOptions}
        />

        <div className="mt-12">
          <SubmitButton>
            { t('actions.next') }
          </SubmitButton>
        </div>
      </Form>
    </div>
  )
}

export default SpecialItemsForm
